import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent, IonHeader, IonFooter, IonLoading} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../zInternal_Features/merchant/components/TakePhoto';
import { Registration_GeoLocation} from './Registration_GeoLocation'

import '../css/zPublic.css';


export function RegisterIndividualModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);

    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let customerFirstNameRef = useRef('');
    let customerLastNameRef = useRef('');
    let merchantPhoneRef = useRef('');
    let merchantCompanyNameRef = useRef('');
    let customerUsernameRef = useRef('');
    let customerPasswordRef = useRef('');
    let [merchantBusinessType, setBusinessType] = useState('C1');
    let [selectedFile, setSelectedFile] = useState(null);
    let [companyLatitude, setCompanyLatitude] = useState(null);
    let [companyLongitude, setCompanyLongitude] = useState(null);

    let [registerFirstName, setRegisterFirstName] = useState('');
    let [registerLastName, setRegisterLastName] = useState('');
    let [mobileNumber, setMobileNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    let [takePhotoStatus, setTakePhotoStatus] = useState(null);

    let [isloading, setLoading] = useState(false);


    let[disableRegisterButton, setDisableRegisterButton] = useState(false);


    function handleFileChange(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    }


    function registerMerchant(e)
    {        

        e.preventDefault();

        setLoading(true);
    

        setDisableRegisterButton(true);

        //  alert('In REGISTER');
        //  alert(acctID);
        //  alert(registerFirstName);
        //  alert(registerLastName);
        //  alert(mobileNumber);

        let formData = new FormData();
        formData.append('Tracker', '72001_registration_individual');
        formData.append('user', 'register_request');
        formData.append('uCustomerFirstName', registerFirstName);
        formData.append('uCustomerLastName', registerLastName);
        formData.append('uCustomerMobileNumber', mobileNumber);
        formData.append('uCompanyName', registerFirstName.replace(/\s+/g, '_')+'_'+registerLastName.replace(/\s+/g, '_'));
        formData.append('uEnterBusinessType', merchantBusinessType);
        //formData.append('uCompanyLatitude', companyLatitude);
        //formData.append('uCompanyLongitude', companyLongitude);
        formData.append('uCreateUsername', customerUsernameRef.current.value.replace(/\s+/g, ''));
        formData.append('uCreatePassword', customerPasswordRef.current.value.replace(/\s+/g, ''));
        formData.append('sessionID', sessionID);    
        formData.append('xImageFile', selectedFile);    
        formData.append('xIDType', "SUBMISSION");    
        formData.append('xIDNumber', "SUBMISSION");    


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'merchants_argsApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert("after fetch");
            alert(data);

            setDisableRegisterButton(false);

            let cols = data.toString().split('|');

            setLoading(false);

            if(cols[0] == "INVALID_REGISTRATION")
            {
                alert(cols[1]);
                //next();
            }
            else if(props.data.source == 'online_pay_register' && cols[0] == 'REGISTRATION_COMPLETED')
            {
                props.closeModal([customerUsernameRef.current.value, customerPasswordRef.current.value]);
            }
            else
            {
                 props.closeModal(false);
            }

        })
        .catch(error => {
            console.error(error);
        })
    }

    function retrieveCurrentGeolocation(event) 
    {
        //alert("in get current registration coordinates");
        // alert(event);
        // alert(event[0]);
        // alert(event[1]);

        setCompanyLatitude(event[0]);
        setCompanyLongitude(event[1]);
    }

    function selectedFileHandler(event)
    {

        setSelectedFile(event);

    }

    function handleSelectBusinessType(event)
    {
        setBusinessType(event[1])
    }

    function handleMobileNumberChange(e) {

        const input = e.detail.value || '';
        if (!input.startsWith('0')) {
            setErrorMessage('Mobile number must start with 0.');
        } else {
            setErrorMessage('');
        }
        setMobileNumber(input);
    };

    function handleLogin()
    {
        props.closeModal([customerUsernameRef.current.value, customerPasswordRef.current.value]);
        
    }
    function closeModalHandler() {

        if(props.data.source == 'online_pay_register')
        {

            props.payCloseModal(false);
        }
        else
        {
            props.closeModal(false);
        }

    }


    function isJPEG(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onloadend = function() {
                const arr = new Uint8Array(reader.result).subarray(0, 4);
                let header = "";
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
    
                }
                
                // JPEG magic number: 0xFFD8
                if (header === "ffd8") {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
    
            reader.onerror = function() {
                reject(new Error("Error reading blob"));
            };
    
            reader.readAsArrayBuffer(blob.slice(0, 4));
        });
    }

    useEffect(() => {

        // alert("in useefect");
        // alert(props.data.source);
        // alert(props.data.register_firstName);
        // alert(props.data.register_lastName);
        // alert(props.data.register_phoneNumber);

        if(props.data.source == 'online_pay_register')
        {

            setRegisterFirstName(props.data.register_firstName);
            setRegisterLastName(props.data.register_lastName);
            setMobileNumber(props.data.register_phoneNumber);

        }

    }, [])

    //alert(props.data.source);
    //alert(acctID);

    return (

            <React.Fragment>
                    <IonModal isOpen={ props.openModal }>
                    <form onSubmit={registerMerchant}>
                      <IonHeader>
                        <IonGrid className='register_header'>
                            <IonRow >
                                <IonCol size='12'>
                                    <h1> INDIVIDUAL REGISTRATION </h1>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>

                    <Registration_GeoLocation gps_location={retrieveCurrentGeolocation} ></Registration_GeoLocation>
                    
                    {props.data.source == 'online_pay_register' && 
                        <IonContent className='appPublic_gridContent'>
                                    <IonGrid >
                                    <IonRow >
                                        <IonCol size='12' >
                                            <h3 style={{ color: 'red' }}> ACCOUNT REQUIRED.  PLEASE SIGN IN OR CREATE ACCOUNT TO COMPLETE PAYMENT. </h3>
                                        </IonCol>
                                    </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>First Name:</label>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Last Name:</label>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' value={registerFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setRegisterFirstName(e.target.value)} required></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' value={registerLastName} placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setRegisterLastName(e.target.value)} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size="6">
                                                <label htmlFor="searchSupplierName">Mobile Number:</label>
                                            </IonCol>
                                            <IonCol size="6">
                                                <IonInput
                                                    className='professional-input'
                                                    id="searchSupplierName"
                                                    placeholder="Enter mobile number"
                                                    type="tel"
                                                    value={mobileNumber}
                                                    onIonChange={(e) => handleMobileNumberChange(e)}
                                                    required/>
                                                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Username:</label>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Password:</label>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' ref={ customerUsernameRef }  placeholder='Enter Username' autocomplete='off' required></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='password' ref={ customerPasswordRef }  placeholder='Enter Password' autocomplete='off' required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                    

                                    {isloading == true && <IonLoading
                                        isOpen={isloading}
                                        message={'Please wait...'}
                                        duration={0} // Show until manually dismissed
                                    />}
                    
                            </IonContent>
                        }

                        {props.data.source != 'online_pay_register' && 
                        <IonContent className='appPublic_gridContent'>
                                    <IonGrid >
                                        <IonRow>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>First Name:</label>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Last Name:</label>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' value={registerFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setRegisterFirstName(e.target.value)} required></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' value={registerLastName} placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setRegisterLastName(e.target.value)} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size="6">
                                                <label htmlFor="searchSupplierName">Mobile Number:</label>
                                            </IonCol>
                                            <IonCol size="6">
                                                <IonInput
                                                    id="searchSupplierName"
                                                    placeholder="Enter mobile number"
                                                    type="tel"
                                                    value={mobileNumber}
                                                    onIonChange={(e) => handleMobileNumberChange(e)}
                                                    required/>
                                                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Username:</label>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <label for='searchSupplierName'>Password:</label>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='text' ref={ customerUsernameRef }  placeholder='Enter Username' autocomplete='off' required></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput className='professional-input' type='password' ref={ customerPasswordRef }  placeholder='Enter Password' autocomplete='off' required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        {/*<IonRow>
                                            <IonCol size='12'>                            
                                                <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                                {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                            </IonCol>
                                            <IonCol size='12'>
                                                <input
                                                    type="file"
                                                    accept="image/jpeg"
                                                    onChange={handleFileChange}
                                                />
                                            </IonCol>
                                        </IonRow>*/}                                        
                                    </IonGrid>

                                    {isloading == true && <IonLoading
                                        isOpen={isloading}
                                        message={'Please wait...'}
                                        duration={0} // Show until manually dismissed
                                    />}
                    
                            </IonContent>
                            }

                        <IonFooter className='grid_footer'>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='6'>
                                     <IonButton type='submit' disabled={disableRegisterButton}>Register</IonButton>
                                    </IonCol>
                                    <IonCol size='6'>
                                    {props.data.source == 'online_pay_register' && <IonButton onClick={() => handleLogin()} disabled={disableRegisterButton}>Login</IonButton>}
                                    <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonFooter>
                        </form>

                    </IonModal>
            </React.Fragment>

    )
}